export default "__VITE_ASSET__1eClIwwn__";